<template>
  <v-layout class="nav-wrapper">
    <v-toolbar flat class="app-navigation">
      <v-toolbar-items class="toolbar-desktop hidden-sm-and-down">
        <div v-for="navigationItem in navigation" :key="navigationItem.title + 'toolbar_desktop'">
          <div class="navigation-item">
            <v-btn flat v-if="navigationItem.child === undefined" :to="navigationItem.path">{{ $t(navigationItem.title) }}</v-btn>
          </div>
          <v-menu v-if="navigationItem.child !== undefined">
            <template v-slot:activator="{ on }">
              <v-toolbar-title v-on="on">
                <div class="navigation-item d-flex align-items-center">
                  <span class="navigation-item-title">{{ $t(navigationItem.title) }}</span>
                  <v-icon dark>arrow_drop_down</v-icon>
                </div>
              </v-toolbar-title>
            </template>

            <v-list>
              <v-list-tile
                v-for="child in navigationItem.child"
                :key="child.title + 'toolbar_child'"
                :to="child.path"
              >
                <v-list-tile-title v-text="$t(child.title)"></v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </div>
      </v-toolbar-items>

      <a v-show="!isFrench" href="https://www.fraserinstitute.org" target="_blank">
        <img alt="logo" class="app-logo hidden-md-and-up"
            src="@/assets/images/logo.png"
        />
      </a>

      <a v-show="isFrench" href="https://www.fraserinstitute.org/fr" target="_blank">
        <img alt="logo" class="app-logo hidden-md-and-up logo-fr"
            src="@/assets/images/logo-fr.png"
        />
      </a>
      <router-link class="map-header-title-link" :to="{name: 'home'}">
        <h1 class="map-header-title-mobile hidden-md-and-up">School Rankings</h1>
      </router-link>
      <div class="social-networks hidden-sm-and-down">
        <a href="https://www.facebook.com/FraserInstitute" title="Facebook" target="_blank">
          <v-icon dark>mdi-facebook</v-icon>
        </a>
        <a href="https://twitter.com/fraserinstitute" title="Twitter" target="_blank">
          <v-icon dark>mdi-twitter</v-icon>
        </a>
        <a href="https://www.linkedin.com/company/the-fraser-institute" title="Linkedin" target="_blank">
          <v-icon dark>mdi-linkedin</v-icon>
        </a>
        <a href="https://www.instagram.com/fraser_institute/" title="Instagram" target="_blank">
          <v-icon dark>mdi-instagram</v-icon>
        </a>
        <a href="https://www.youtube.com/user/FraserInstitute" title="Youtube" target="_blank">
          <v-icon dark>mdi-youtube</v-icon>
        </a>
      </div>
      <v-spacer class="hidden-md-and-up"></v-spacer>
      <v-toolbar-side-icon @click="showOverlayMenu = true" class="toolbar-mobile hidden-md-and-up"/>
    </v-toolbar>
    <v-dialog
      v-model="showOverlayMenu"
      content-class="overlay-menu"
      origin="top center"
      transition="slide-y-transition"
      attach=".nav-wrapper"
    >
    <v-flex class="overlay-menu-content">

    <v-toolbar
      flat
    >
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn
        flat
        @click.stop="showOverlayMenu = false"
        >
          <i class="icon"></i>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
<v-list>
  <template v-for="navigationItem in navigation">
    <template v-if="navigationItem.child === undefined">
      <v-list-tile :key="navigationItem.title">

        <v-list-tile-content>
          <v-list-tile-title>
            <a :href="navigationItem.path">
              {{ $t(navigationItem.title) }}
            </a>
          </v-list-tile-title>
        </v-list-tile-content>

      </v-list-tile>
    </template>
    <template v-else>
      <v-list-tile v-for="child in navigationItem.child" :href="child.path" :key="child.title + 'mobile_menu_child'">

        <v-list-tile-content>
          <v-list-tile-title>
            <a :href="child.path">
              {{ $t(child.title) }}
            </a>
          </v-list-tile-title>
        </v-list-tile-content>

      </v-list-tile>
    </template>
  </template>
</v-list>
</v-flex>
    </v-dialog>
  </v-layout>





</template>

<script>
  export default {
    name: "Navigation",
    data() {
      return {
        showOverlayMenu: false
      }
    },
    methods: {
    },
    computed: {
      isFrench() {
        return this.$store.state.currentLanguage === 'fr';
      },
      navigation: {
        get() {
          return this.$store.state.navigationMenu;
        }
      }
    }
  }
</script>
